'use client'

import { useTranslation } from '@/hooks/client/use-translation'

const inputClass =
  'border-navy/25 text-navy focus:border-navy focus-visible:outline-navy mt-2 w-full rounded-lg border bg-white px-3 py-2.5 text-base focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-60'
const labelClass = 'text-navy text-sm font-medium'

export const PartnershipFields = ({ disabled }: { disabled: boolean }) => {
  const { t } = useTranslation()
  return (
    <fieldset disabled={disabled} className="space-y-5">
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="partnership-name" className={labelClass}>
            {t('mediaKit.contact.name', 'Name')}
          </label>
          <input id="partnership-name" name="firstName" autoComplete="name" required className={inputClass} />
        </div>
        <div>
          <label htmlFor="partnership-company" className={labelClass}>
            {t('mediaKit.contact.company', 'Company (optional)')}
          </label>
          <input id="partnership-company" name="company" autoComplete="organization" className={inputClass} />
        </div>
      </div>
      <div>
        <label htmlFor="partnership-email" className={labelClass}>
          {t('subscription.email', 'Email')}
        </label>
        <input id="partnership-email" name="email" type="email" autoComplete="email" required className={inputClass} />
      </div>
      <div>
        <label htmlFor="partnership-message" className={labelClass}>
          {t('mediaKit.contact.message', 'What do you have in mind?')}
        </label>
        <p id="partnership-message-help" className="text-navy/75 mt-1 text-sm leading-relaxed">
          {t('mediaKit.contact.messageHelp', 'Share your audience, objective, and timeline.')}
        </p>
        <textarea
          id="partnership-message"
          name="message"
          aria-describedby="partnership-message-help"
          required
          rows={4}
          className={inputClass}
        />
      </div>
      <div hidden aria-hidden="true">
        <input name="website" type="text" tabIndex={-1} autoComplete="off" />
      </div>
    </fieldset>
  )
}
